import { render, staticRenderFns } from "./WebhookCompany.vue?vue&type=template&id=0f98f528&scoped=true&lang=pug&"
import script from "./WebhookCompany.vue?vue&type=script&lang=ts&"
export * from "./WebhookCompany.vue?vue&type=script&lang=ts&"
import style0 from "./WebhookCompany.vue?vue&type=style&index=0&id=0f98f528&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f98f528",
  null
  
)

export default component.exports